import { topicTags } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-hashtag text-primary-500 mr-2"></i>
              热门话题
            </h2>
            <p className="text-foreground-500 text-sm">点击标签浏览你感兴趣的瓜料分类</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {topicTags.map((tag, idx) => (
              <a
                key={idx}
                href="#ranking"
                className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 hover:bg-background-200 rounded-xl transition-colors cursor-pointer no-underline"
              >
                <span className={`w-12 h-12 flex items-center justify-center rounded-full text-xl ${
                  tag.hot
                    ? 'bg-primary-100 text-primary-500'
                    : 'bg-secondary-100 text-secondary-500'
                }`}>
                  <i className={tag.icon}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {tag.name}
                </span>
                <span className="text-xs text-foreground-500">{tag.count}</span>
                {tag.hot && (
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium">
                    热门
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}